import { useState } from "react";

type ModalStatDateProps = {
  startTime: string;
  endTime: string;
  onChange: (newStart: Date, newEnd: Date) => void;
};

const ModalStatDate = ({ startTime, endTime, onChange }: ModalStatDateProps) => {
  const start = new Date(startTime);
  const end = new Date(endTime);

  const [startMonth, setStartMonth] = useState((start.getMonth() + 1).toString().padStart(2, '0'));
  const [startYear, setStartYear] = useState(start.getFullYear().toString());
  const [endMonth, setEndMonth] = useState((end.getMonth() + 1).toString().padStart(2, '0'));
  const [endYear, setEndYear] = useState(end.getFullYear().toString());

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 4 }, (_, i) => currentYear - 3 + i);

  const handleSubmit = () => {
    const newStart = new Date(`${startYear}-${startMonth}-01`);
    const newEnd = new Date(`${endYear}-${endMonth}-01`);
    onChange(newStart, newEnd);
  };

  return (
    <div className="modal fade" id="modalStatDate" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Velg periode</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Lukk"></button>
          </div>
          <div className="modal-body">
            <h2 className="fs-6">Fra dato</h2>
            <div className="d-flex gap-3">
              <select className="form-select" aria-label="Fra måned" value={startMonth} onChange={(e) => setStartMonth(e.target.value)}>
                {Array.from({ length: 12 }, (_, i) => {
                  const date = new Date(currentYear, i, 1);
                  return (
                    <option key={i} value={(i + 1).toString().padStart(2, '0')}>
                      {date.toLocaleDateString('nb-NO', { month: 'long' })}
                    </option>
                  );
                })}
              </select>
              <select className="form-select" aria-label="Fra år" value={startYear} onChange={(e) => setStartYear(e.target.value)}>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <h2 className="fs-6 mt-3">Til dato</h2>
            <div className="d-flex gap-3">
              <select className="form-select" aria-label="Til måned" value={endMonth} onChange={(e) => setEndMonth(e.target.value)}>
                {Array.from({ length: 12 }, (_, i) => {
                  const date = new Date(currentYear, i, 1);
                  return (
                    <option key={i} value={(i + 1).toString().padStart(2, '0')}>
                      {date.toLocaleDateString('nb-NO', { month: 'long' })}
                    </option>
                  );
                })}
              </select>
              <select className="form-select" aria-label="Til år" value={endYear} onChange={(e) => setEndYear(e.target.value)}>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal">Avbryt</button>
            <button className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit}>Endre periode</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalStatDate;
